import React from 'react';
import { useSelector } from 'react-redux';

import { getThemeColorClass } from '../../../../utils/helpers/themeHelpers';

import { selectDarkMode } from '../../../../userBrowserSettings/store/browserSettings.selectors';

import './buttons/content/ToolbarContent.scss';
import './buttons/ToolbarButtons.scss';
import './EditorToolbar.scss';

export const EDITOR_TOOLBAR_ID = 'tiptap-editor-toolbar';

const classes = {
    editorToolbar: 'editor-toolbar justify-content-between',
    buttonWrapper: 'd-flex',
    toolbarSettingsSection: 'toolbar-settings-section d-flex',
};

const EditorToolbar = ({ toolbarSections, versionHistorySection, moreDropdown }) => {
    const darkMode = useSelector(selectDarkMode);

    return (
        <div
            id={EDITOR_TOOLBAR_ID}
            className={`${classes.editorToolbar} ${getThemeColorClass(darkMode)}`}
        >
            <div className={classes.buttonWrapper}>{toolbarSections}</div>
            <div className={classes.toolbarSettingsSection}>
                {versionHistorySection}
                {moreDropdown}
            </div>
        </div>
    );
};

export default EditorToolbar;
